<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import { mapGetters } from 'vuex'
export default {
    name: 'CanteenBanner',
    components: { ImageWrapper },
    computed: {
        ...mapGetters({
            smDevice: 'smDevice',
            size: 'size',
            canteenNext: 'canteen/next',
            hasCanteenList: 'canteen/hasList',
        }),
        defaultText() {
            return this.$user.onlyCloudCanteen || !this.canteenNext
        },
        iscanteenNextToday() {
            return this.canteenNext?.deliveryTime
                ? this.$moment().isSame(this.canteenNext?.deliveryTime, 'day')
                : null
        },
        leftToOrder() {
            if (!this.canteenNext?.cutoffTime) return null
            const hours = this.$moment(this.canteenNext?.cutoffTime).diff(this.$moment(), 'hours')
            if (hours > 24) {
                const days = this.$moment(this.canteenNext?.cutoffTime).diff(this.$moment(), 'days')
                return this.$t('canteen.banner.days', { count: days }, days)
            } else if (hours < 1) {
                const minutes = this.$moment(this.canteenNext?.cutoffTime).diff(
                    this.$moment(),
                    'minutes'
                )
                return this.$t('canteen.banner.minutes', { count: minutes }, minutes)
            } else return this.$t('canteen.banner.hours', { count: hours }, hours)
        },
        textStyle() {
            return `mx-xxl-2 mb-xxl-0 text-uppercase font-weight-bold ${
                this.size === 'xs' ? 'w-50 font-size-xs' : ''
            }`
        },
        clickable() {
            return !this.$user.onlyCloudCanteen && (this.canteenNext?.isOpen || this.hasCanteenList)
        },
    },
}
</script>

<template lang="pug">
component.canteen-banner(
    :class="{'cursor-pointer': clickable}"
    :is="clickable ? 'router-link' : 'div'"
    :to="clickable ? {name: 'canteen-pickup'} : undefined"
    :tag="clickable ? 'div' : undefined")
    .d-flex.flex-column.align-items-start.align-items-xxl-center.flex-xxl-row
            compontent.mb-2.mb-xxl-0.mr-xxl-2.text-uppercase.text-white(:is="size === 'xs' ? 'h3' : 'h2'")
                template(v-if="defaultText") {{$t('canteen.banner.title')}}
                template(v-else) {{canteenNext.name}}
            p.mb-2(v-if="defaultText" :class="textStyle" v-html="$t('canteen.banner.desc')")
            template(v-else)
                p.mb-2.text-nowrap(:class="textStyle")
                    template(v-if="!iscanteenNextToday") {{ canteenNext.deliveryTime | toDayMonth(size === 'xs' ? 1 : 4) }}&nbsp;
                    | {{ canteenNext.deliveryTime | toTimeRange }}
                p.mb-0.text-white(:class="textStyle")
                    template(v-if="canteenNext.isOpen") {{ leftToOrder }}
                    template(v-else) {{$t('canteen.banner.ordering_opens')}}
                p.mb-2(:class="textStyle")
                    template(v-if="canteenNext.isOpen") {{$t('canteen.banner.left_to_order')}}
                    template(v-else)  {{$t('canteen.banner.at', {date:$options.filters.toDayMonth(canteenNext.openTime, 1), time:$options.filters.toHour(canteenNext.openTime)})}}

            button.btn.btn-light.btn-pill.text-uppercase.btn-xs.btn-lg-sm.d-inline-flex.mt-auto.mt-sm-0(v-if="clickable")
                | {{$t('canteen.banner.btn')}}

    image-wrapper.canteen-banner-image(
        :src="smDevice ? '/images/cloud_canteen_banner.svg' : '/images/cloud_canteen_banner_lg.svg'"
        :key="`canteenBannerImage${smDevice ? '' :'Lg'}`"
        background contain)
</template>
